export const colors = {
  colorSuccess: '#28a745',
  colorWarning: '#FF7518',
  colorDanger: '#FF0039',
  colorInfo: '#0080FF',
  iconUpdate: '#1a62b3',
  backgroundColorRow: '#f2f2f2',
  iconUser: '#a1a6a9',
  iconDelete: '#7E7E7E'
};
